import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Icon,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Text,
  VStack
} from "@chakra-ui/react";
import { FaBullhorn, FaGift, FaMoneyBillWave, FaCheckCircle } from "react-icons/fa";
import FullScreenSection from "./FullScreenSection";
import Disclosurre from "./disclosurre";

const campaigns = [
  {
    title: "No Promotions Available",
    badge: "Check Back Soon",
    icon: FaGift,
    color: "gray.400",
    headline: "There is currently no promotion at this time.",
    description:
      "Promotions will be updated here when they become available. Please check back later for exciting offers!",
    terms: [
      "No active promotions at this time",
      "Check this page for future updates",
      "Standard approval and eligibility requirements apply"
    ]
  }
];

export default function Promotion1() {
  return (
    <VStack spacing={0} width="100%">   
      <FullScreenSection
        justifyContent="center"
        alignItems="center"
        isDarkBackground={false}
        backgroundColor="gray.50"
        py={100}
      >
        <VStack spacing={12} maxW="1200px" width="100%">
          <VStack spacing={4} textAlign="center" maxW="900px">
            <HStack spacing={3} justify="center">
              <Icon as={FaBullhorn} boxSize={10} color="black.500" />
              <Heading fontSize={{ base: "2.2rem", md: "3rem" }} fontWeight="bold">
                Promotions
              </Heading>
            </HStack>
            <Text fontSize="1.2rem" color="gray.600" lineHeight="1.8">
              Stay tuned for our latest promotions and offers.
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 1 }} spacing={10} width="100%" maxW="760px">
            {campaigns.map((campaign) => (
              <Box
                key={campaign.title}
                bg="white"
                borderRadius="xl"
                boxShadow="lg"
                p={{ base: 6, md: 8 }}
                border="2px solid"
                borderColor="gray.200"
                transition="all 0.3s ease"
                _hover={{ transform: "translateY(-6px)", boxShadow: "2xl", borderColor: campaign.color }}
              >
                <Flex align="center" justify="space-between" mb={4} flexWrap="wrap" gap={3}>
                  <HStack spacing={3}>
                    <Icon as={campaign.icon} boxSize={9} color={campaign.color} />
                    <Heading fontSize="1.6rem">{campaign.title}</Heading>
                  </HStack>
                  <Badge colorScheme="gray" variant="subtle" px={3} py={1} borderRadius="full">
                    {campaign.badge}
                  </Badge>
                </Flex>

                <Text fontSize="1.1rem" fontWeight="semibold" color="gray.800" mb={3}>
                  {campaign.headline}
                </Text>
                <Text color="gray.600" lineHeight="1.8" mb={5}>
                  {campaign.description}
                </Text>

                <Box bg="gray.50" borderRadius="lg" p={4}>
                  <Text fontWeight="semibold" color="gray.700" mb={3}>
                    Terms & Conditions
                  </Text>
                  <List spacing={2} color="gray.600">
                    {campaign.terms.map((term) => (
                      <ListItem key={term}>
                        <ListIcon as={FaCheckCircle} color={campaign.color} />
                        {term}
                      </ListItem>
                    ))}
                  </List>
                </Box>

                <Button
                  as="a"
                  href="/apply"
                  mt={6}
                  display="flex"
                  w="fit-content"
                  mx="auto"
                  bg="gray.400"
                  color="white"
                  borderRadius="full"
                  px={8}
                  h="48px"
                  _hover={{ bg: "gray.500" }}
                  cursor="not-allowed"
                  disabled
                >
                  No Promotions
                </Button>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </FullScreenSection>
      <Disclosurre />
    </VStack>
  );
}
